<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="listPage()"
    />&nbsp;&nbsp;Publish a News Update
  </div>
  <div class="example-header">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="fulllwidth">
            <mat-form-field>
              <input
                type="text"
                formControlName="newsTitle"
                matInput
                placeholder="Headline"
              />
              <!-- <mat-error *ngIf="form.get('SchemtTitle').hasError('required')">
                              </mat-error> -->
            </mat-form-field>

            <mat-form-field>
              <input
                type="text"
                formControlName="newsSource"
                matInput
                placeholder="Source"
              />
              <!-- <mat-error *ngIf="form.get('SchemtTitle').hasError('required')">
                              </mat-error> -->
            </mat-form-field>
            <div>
              <span>
                <mat-form-field appearance="fill" style="width: 48%">
                  <mat-label>Choose a date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="date"
                    [max]="getToday()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </span>
              &nbsp;&nbsp;
              <span>
                <mat-form-field appearance="fill" style="width: 48%">
                  <mat-label>Language</mat-label>
                  <mat-select formControlName="languages" multiple>
                    <mat-option
                      *ngFor="let language of languageList"
                      [value]="language.value"
                    >
                      {{ language.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
            </div>
            <div class="row">
              <div class="col-sm-9">
                <span>
                  <div class="file-upload-header">Thumbnail image</div>
                  <input
                    type="file"
                    name="image"
                    class="file-input"
                    (change)="newsFileSelected($event)"
                    #fileUpload
                  />
                  <button
                    type="button"
                    class="file-upload"
                    (click)="fileUpload.click()"
                  >
                    <mat-icon>cloud_upload</mat-icon>
                  </button>
                </span>
                <div
                  *ngIf="f['image'].touched && f['image'].invalid"
                  style="font-size: 1rem"
                >
                  <mat-error
                    *ngIf="f['image'].errors && f['image'].errors['required']"
                    >Image is required.</mat-error
                  >
                  <!-- <div *ngIf="f['name'].errors && f['name'].errors['minlength']">Name should be 3 character.</div> -->
                </div>
                &nbsp;&nbsp;
              </div>
              <div class="col-sm-3">
                <img
                  [src]="imageSrc"
                  class="imagePreview"
                  alt=""
                  accept="image/*"
                />
              </div>
            </div>
            <mat-form-field>
              <input
                type="text"
                formControlName="attachlink"
                id="attachlink"
                matInput
                placeholder="Link"
              />
            </mat-form-field>

            <mat-form-field>
              <input
                type="text"
                maxlength="100"
                rows="2"
                formControlName="remark"
                matInput
                placeholder="Remark"
              />
              <!-- <mat-error *ngIf="form.get('SchemtTitle').hasError('required')">
                              </mat-error> -->
            </mat-form-field>

            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <button
                  mat-button
                  type="submit"
                  [disable]="disable"
                  class="submitBtn pull-right"
                >
                  Share
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
